import { PlanScope } from '@/lib/types';

// The scope identity colors used across the planner: violet (DS slot4)
// marks the shared workspace plan, brand orange the caller's own "My Plan".
// The scope tab strip's dots and the calendar day cells use the same
// mapping, so a color always means the same slot.
export const SCOPE_DOT_COLOR: Record<PlanScope, string> = {
  workspace: 'slot4.fg',
  personal: 'brand.solid',
};

export const SCOPE_LABEL: Record<PlanScope, string> = {
  workspace: 'Workspace',
  personal: 'My plan',
};
